<template>
  <div class="container">
	<button v-if="!qrCode && !connected && !getStatusConnection" @click="connectWhatsApp" class="btn-whatsapp btn-pay-add">
      Conectar
    </button>
	<div class="loading-status" v-if="!qrCode && !connected && getStatusConnection">
		<h3 class="qr-container">Aguarde</h3>
		<div class="container-status">
			<span class="message">Verificando estado</span>
			<div class="loading-dots">
				<span></span>
				<span></span>
				<span></span>
			</div>
		</div>
    </div>

    <div v-if="qrCode" class="qr-container">
		<div class="no-connected">Escaneie o QR Code</div>
		<img :src="qrCode" alt="QR Code" />
    </div>

	<div v-if="connected"  class="connected-status">
		<div class="connected">
			✅ Conectado
		</div>
		<button @click="disconnectWhatsApp" class="btn-whatsapp btn-pay-del">
			Desconectar
		</button>
		<hr />
	</div>

	<div style="margin-top: -150px;" v-if="connected && showSendMessage">
		<h3>Enviar mensaje</h3>

		<input
			v-model="number"
			placeholder="5511999999999"
		/>

		<div class="d-flex container-send">
			<textarea
				v-model="message"
				placeholder="Messagem"
			/>

			<button
				class="btn-send center"
				@click="sendMessage"
				:disabled="!message || !number"
			>
				<SendIcon color="green"/>
			</button>
		</div>
	</div>
  </div>
</template>

<script>
	import { io } from "socket.io-client";
	import environment from "@/environment";
	import { UsersService } from "@/services/users";
	import { WhatsAppService } from "@/services/whatsApp.js";

	export default {
		data () {
			return {
				socket: null,
				qrCode: null,
				connected: false,

				number: "",
				message: "",
				getStatusConnection: true,

				host: environment.WHATSAPP_API || "http://localhost:3000",
				usersService: new UsersService(),
				whatsAppService: new WhatsAppService(),
				showSendMessage: Boolean(this.userId === 1)

			};
		},

		props: {
			userId: {
				type: Number,
				default: 1
			}
		},

		async mounted () {
			this.getDataConnection();
			this.initializeSocket();
		},

		beforeDestroy () {
			this.destroySocket();
		},

		methods: {
			async getDataConnection () {
				try {
					this.connected = false;
					const result = await this.whatsAppService.getStatusWhatsApp();
					this.connected = Boolean(result?.connected);
					this.getStatusConnection = false;

				} catch (e) {
					console.error(e);
				}

			},

			async initializeSocket () {
				this.socket = io(this.host, {
					path: "/socket.io/",
					transports: ["websocket", "polling"]
				});

				this.socket.on("connect", () => {
					console.log("Conectado a Socket");
					this.socket.emit("join_user_room", this.userId);
				});

				// recibir QR
				this.socket.on("qrCode", async (qrImage) => {
					console.log("Recibiendo qrCode");
					this.connected = false;
					this.qrCode = qrImage;
					this.getStatusConnection = false;
				});

				// autenticado
				this.socket.on("authenticated", client => {
					this.connected = true;
				});

				// conectado
				this.socket.on("ready", data => {
					this.connected = true;
					this.qrCode = null;
					this.getStatusConnection = false;
				});

				// desconectado
				this.socket.on("disconnected", reason => {
					console.log("WhatsApp Desconectado");
					this.connected = false;
					this.getStatusConnection = false;
				});

				this.socket.on("qrCodeNoRead", reason => {
					this.socket.disconnect();
					this.qrCode = null;
					this.connected = false;
					this.getStatusConnection = false;
				});
			},

			async connectWhatsApp () {
				///this.initializeSocket();
				try {
					await this.whatsAppService.connectWhatsApp();
				} catch (error) {
					console.error(error);
				}
			},
			async disconnectWhatsApp () {
				try {
					const resp = await this.whatsAppService.disconnectWhatsApp();
					if (resp.success) {
						this.connected = false;
						this.getStatusConnection = false;
						this.qrCode = null;
					}
				} catch (error) {
					console.error(error);
				}
			},

			async sendMessage () {
				try {

					const response = await this.whatsAppService.sendMessage({
						number: this.number,
						message: this.message
					});

					if (response.success) {
						this.number = null;
						this.message = null;
					} else {
						this.connected = false;
					}

				} catch (error) {
					const msgError = error.response.data.message || "Erro ao tentar conectar!";
					const retrySend = (await this.$swal({
						title: "Erro",
						text: `WhatsApp: ${msgError} Deseja tentar novamente?`,
						type: "error",
						showCancelButton: true,
						cancelButtonColor: "#A6A8AB",
						confirmButtonColor: "#DD6B55",
						cancelButtonText: "Não",
						confirmButtonText: "Sim",
						reverseButtons: true
					})).value;

					if (retrySend) {
						this.sendMessage();
					} else {
						this.connected = false;


					}
					console.error(error);
				}
			},

			destroySocket () {
				if (this.socket) {
					this.socket.removeAllListeners();
					this.socket.disconnect();
					this.socket = null;
				}
			}
		}
	};
</script>

<style scoped>
.container {
  max-width: 500px;
  margin: auto;
  padding: 20px;
  text-align: center;
}

.qr-container {
  margin-top: 20px;
}

.qr-container img {
  width: 300px;
}

.connected {
	margin-top: 20px;
	color: green;
	font-weight: bold;
	font-family: 'Roboto Condensed Medium';
	font-size: 1.25rem;
	margin-bottom: 20px;
}

.no-connected {
	margin-top: 20px;
	font-weight: bold;
	font-family: 'Roboto Condensed Medium';
	font-size: 1.25rem;
	margin-bottom: 20px;
}

input,
textarea {
  width: 100%;
  margin-top: 10px;
  padding: 10px;
}

button {
  margin-top: 10px;
  padding: 10px 20px;
}

.container-send {
	display: flex;
	align-items: center;
	text-align: center;
	justify-content: center;
}

.btn-whatsapp {
	width: 10rem;
	height: 3rem;
	font-family: 'Roboto Condensed Medium';
	font-size: 1.25rem;
	color: white;
	border-radius: 4px;
	border-style: none;
}

.btn-send {
	width: 40px;
	height: 40px;
	border-radius: 4px;
	border-color: green;
	padding: 6px;
	margin-left: 3px;
	border-style: none;
	background: none;
}

.container-status {
	display: flex;
	margin-top: 50px;
	align-items: first baseline;
	justify-content: center;
	gap: 8px;
}

.loading-status {
	height: 300px;
}

.connected-status {
	height: 300px;
	margin-top: 50px;
	justify-content: center;
}

.loading-dots {
  display: flex;
  gap: 4px;
}

.loading-dots span {
  width: 6px;
  height: 6px;
  background-color: black;
  border-radius: 50%;
  animation: bounce 1.4s infinite ease-in-out both;
}

.loading-dots span:nth-child(1) {
  animation-delay: -0.32s;
}

.loading-dots span:nth-child(2) {
  animation-delay: -0.16s;
}

.loading-dots span:nth-child(3) {
  animation-delay: 0s;
}

@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(0.5);
    opacity: 0.4;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

.message {
	font-family: 'Roboto Condensed Medium';
	font-size: 1.25rem;
}

</style>